import { render, staticRenderFns } from "./f2.vue?vue&type=template&id=69507faf&scoped=true&"
import script from "./f2.vue?vue&type=script&lang=js&"
export * from "./f2.vue?vue&type=script&lang=js&"
import style0 from "./f2.vue?vue&type=style&index=0&id=69507faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69507faf",
  null
  
)

export default component.exports